class LaunchOffer {
  constructor(element) {
    this.element = element;
    this.countdownElement = this.element.querySelector('[data-countdown-end]');

    // Get ALL dropdowns (first and second)
    this.dropdowns = [];
    const dropdownElements = this.element.querySelectorAll('[data-dropdown]');

    console.log(`[LaunchOffer] Found ${dropdownElements.length} dropdown(s)`);

    // Initialize each dropdown with its data
    dropdownElements.forEach((dropdown, index) => {
      const button = dropdown.querySelector('[data-dropdown-toggle]');
      const menu = dropdown.querySelector('[data-dropdown-menu]');
      const items = dropdown.querySelectorAll('.launch-offer__dropdown-item');

      console.log(`[LaunchOffer] Dropdown ${index}:`, {
        hasButton: !!button,
        hasMenu: !!menu,
        itemsCount: items.length,
        defaultHandle: dropdown.dataset.defaultProductHandle,
        defaultVariantId: dropdown.dataset.defaultProductVariantId
      });

      this.dropdowns.push({
        element: dropdown,
        button: button,
        menu: menu,
        items: items,
        selectedProduct: null
      });
    });
    
    this.isOfferUsed = false;
    this.limitToOne = this.element.dataset.limitToOne !== 'false';

    if (this.countdownElement) {
      this.endDate = new Date(this.countdownElement.dataset.countdownEnd).getTime();
      this.initCountdown();
    }

    // Check offer status BEFORE loading default products
    this.checkOfferStatus().then(async () => {
      await this.loadDefaultProducts();
      this.initAllDropdowns();
    });

    this.initAddToCartInterceptor();
    this.initCartListeners();
  }

  async loadDefaultProducts() {
    for (let index = 0; index < this.dropdowns.length; index++) {
      const dropdown = this.dropdowns[index];
      const defaultHandle = dropdown.element.dataset.defaultProductHandle;
      const defaultVariantId = dropdown.element.dataset.defaultProductVariantId;
      const defaultPrice = dropdown.element.dataset.defaultProductPrice;

      if (defaultHandle && defaultVariantId && defaultPrice) {
        // Use configured default product
        dropdown.selectedProduct = {
          handle: defaultHandle,
          variantId: parseInt(defaultVariantId),
          price: parseInt(defaultPrice)
        };
        console.log(`[LaunchOffer] Dropdown ${index} loaded default:`, dropdown.selectedProduct);
      } else {
        // No default configured, auto-select the first item in the list
        console.log(`[LaunchOffer] Dropdown ${index} has ${dropdown.items.length} items available`);
        const firstItem = dropdown.items[0];
        if (firstItem) {
          console.log(`[LaunchOffer] First item found:`, firstItem);
          const productHandle = firstItem.dataset.productHandle;
          const productTitle = firstItem.dataset.productTitle;
          const productImage = firstItem.dataset.productImage;
          const variantId = firstItem.dataset.variantId;
          const variantPrice = firstItem.dataset.variantPrice;

          console.log(`[LaunchOffer] Dropdown ${index} no default, auto-selecting first item:`, productHandle, 'variant:', variantId);

          // Use data attributes directly if available (variant selection)
          if (variantId && variantPrice) {
            dropdown.selectedProduct = {
              handle: productHandle,
              variantId: parseInt(variantId),
              price: parseInt(variantPrice)
            };
            console.log(`[LaunchOffer] Dropdown ${index} auto-selected from data attributes:`, dropdown.selectedProduct);
            this.updateDropdownUI(dropdown, productTitle, productImage);
          } else {
            // Fallback: fetch product data
            try {
              const response = await fetch(`/products/${productHandle}.js`);
              const productData = await response.json();

              if (productData && productData.variants && productData.variants.length > 0) {
                dropdown.selectedProduct = {
                  handle: productHandle,
                  variantId: productData.variants[0].id,
                  price: productData.variants[0].price
                };
                console.log(`[LaunchOffer] Dropdown ${index} auto-selected from fetch:`, dropdown.selectedProduct);
                this.updateDropdownUI(dropdown, productTitle, productImage);
              }
            } catch (error) {
              console.error(`[LaunchOffer] Error auto-selecting product for dropdown ${index}:`, error);
            }
          }
        }
      }
    }

    this.updateComparePrice();
  }

  initAllDropdowns() {
    this.dropdowns.forEach((dropdown, index) => {
      if (!dropdown.button || !dropdown.menu) return;
      
      // Toggle dropdown
      dropdown.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleDropdown(index);
      });

      // Select product
      dropdown.items.forEach(item => {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          this.selectProduct(item, index);
        });
      });
    });

    // Close all dropdowns when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.element.contains(e.target)) {
        this.closeAllDropdowns();
      }
    });
  }

  toggleDropdown(index) {
    const dropdown = this.dropdowns[index];
    const isExpanded = dropdown.button.getAttribute('aria-expanded') === 'true';
    
    // Close all dropdowns first
    this.closeAllDropdowns();
    
    // Open this one if it was closed
    if (!isExpanded) {
      dropdown.button.setAttribute('aria-expanded', 'true');
      dropdown.menu.removeAttribute('hidden');
    }
  }

  closeAllDropdowns() {
    this.dropdowns.forEach(dropdown => {
      if (dropdown.button && dropdown.menu) {
        dropdown.button.setAttribute('aria-expanded', 'false');
        dropdown.menu.setAttribute('hidden', '');
      }
    });
  }

  async selectProduct(item, dropdownIndex) {
    const dropdown = this.dropdowns[dropdownIndex];
    const productTitle = item.dataset.productTitle;
    const productImage = item.dataset.productImage;
    const productHandle = item.dataset.productHandle;
    const variantId = item.dataset.variantId;
    const variantPrice = item.dataset.variantPrice;

    console.log(`Selecting product for dropdown ${dropdownIndex}:`, productHandle, 'variant:', variantId);

    // Use data attributes directly if available (variant selection)
    if (variantId && variantPrice) {
      dropdown.selectedProduct = {
        handle: productHandle,
        variantId: parseInt(variantId),
        price: parseInt(variantPrice)
      };

      console.log(`Product selected from data attributes:`, dropdown.selectedProduct);
      this.updateComparePrice();
    } else {
      // Fallback: fetch product data if no variant data attributes
      try {
        const response = await fetch(`/products/${productHandle}.js`);
        const productData = await response.json();

        if (productData && productData.variants && productData.variants.length > 0) {
          dropdown.selectedProduct = {
            handle: productHandle,
            variantId: productData.variants[0].id,
            price: productData.variants[0].price
          };

          console.log(`Product selected from fetch:`, dropdown.selectedProduct);
          this.updateComparePrice();
        }
      } catch (error) {
        console.error('Error fetching product:', error);
      }
    }

    // Update UI
    this.updateDropdownUI(dropdown, productTitle, productImage);

    // Close dropdown
    dropdown.button.setAttribute('aria-expanded', 'false');
    dropdown.menu.setAttribute('hidden', '');
  }

  updateDropdownUI(dropdown, productTitle, productImage) {
    const selectedContainer = dropdown.button.querySelector('.launch-offer__dropdown-selected');
    
    if (!selectedContainer) {
      const placeholder = dropdown.button.querySelector('.launch-offer__placeholder');
      if (placeholder) {
        placeholder.outerHTML = `
          <div class="launch-offer__dropdown-selected">
            ${productImage ? `<img src="${productImage}" alt="${productTitle}" class="launch-offer__product-image" loading="lazy" width="40" height="40">` : ''}
            <span class="launch-offer__product-name p-medium fw-6">${productTitle}</span>
          </div>
        `;
      }
    } else {
      const imgEl = selectedContainer.querySelector('.launch-offer__product-image');
      const nameEl = selectedContainer.querySelector('.launch-offer__product-name');

      if (imgEl && productImage) {
        imgEl.src = productImage;
        imgEl.alt = productTitle;
      } else if (!imgEl && productImage) {
        selectedContainer.insertAdjacentHTML('afterbegin',
          `<img src="${productImage}" alt="${productTitle}" class="launch-offer__product-image" loading="lazy" width="40" height="40">`
        );
      }

      if (nameEl) {
        nameEl.textContent = productTitle;
      }
    }
  }

  updateComparePrice() {
    if (this.isOfferUsed) return;

    // Calculate total gift price from all selected products
    let totalGiftPrice = 0;
    this.dropdowns.forEach(dropdown => {
      if (dropdown.selectedProduct && dropdown.selectedProduct.price) {
        totalGiftPrice += dropdown.selectedProduct.price;
      }
    });

    console.log('Total gift price:', totalGiftPrice);

    if (totalGiftPrice <= 0) return;

    const comparePriceElements = document.querySelectorAll('.product-form__compare-price');

    comparePriceElements.forEach(element => {
      if (!element.dataset.originalPrice) {
        element.dataset.originalPrice = element.textContent;
      }

      const originalPrice = parseInt(element.dataset.originalPrice.replace(/[^\d]/g, ''));
      const newTotalPrice = originalPrice + totalGiftPrice;
      const formattedPrice = window.formatPrice(newTotalPrice);

      element.textContent = formattedPrice;

      const parent = element.parentElement;
      if (parent && parent.tagName === 'S') {
        parent.style.display = '';
      }
    });
  }

  initCountdown() {
    this.updateCountdown();
    this.countdownInterval = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance < 0) {
      clearInterval(this.countdownInterval);
      this.setCountdownValues(0, 0, 0, 0);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.setCountdownValues(days, hours, minutes, seconds);
  }

  setCountdownValues(days, hours, minutes, seconds) {
    const daysEl = this.countdownElement.querySelector('[data-days]');
    const hoursEl = this.countdownElement.querySelector('[data-hours]');
    const minutesEl = this.countdownElement.querySelector('[data-minutes]');
    const secondsEl = this.countdownElement.querySelector('[data-seconds]');

    if (daysEl) daysEl.textContent = String(days).padStart(2, '0');
    if (hoursEl) hoursEl.textContent = String(hours).padStart(2, '0');
    if (minutesEl) minutesEl.textContent = String(minutes).padStart(2, '0');
    if (secondsEl) secondsEl.textContent = String(seconds).padStart(2, '0');
  }

  initAddToCartInterceptor() {
    const addToCartButtons = document.querySelectorAll('.product-form__submit[data-action="add-to-cart"]');

    addToCartButtons.forEach(button => {
      button.addEventListener('click', async (e) => {
        // Check if we have at least one selected product
        const hasSelectedProducts = this.dropdowns.some(d => d.selectedProduct && d.selectedProduct.variantId);
        
        if (hasSelectedProducts) {
          e.preventDefault();
          e.stopImmediatePropagation();

          await this.addAllProductsToCart(button);
        }
      }, true);
    });
  }

  async addAllProductsToCart(originalButton) {
    const variantId = originalButton.getAttribute('variant-id');
    const qty = originalButton.getAttribute('data-quantity') || 1;
    const properties = originalButton.getAttribute('data-properties')
      ? JSON.parse(originalButton.getAttribute('data-properties'))
      : null;

    const originalText = originalButton.innerHTML;
    originalButton.disabled = true;
    originalButton.setAttribute('aria-busy', 'true');
    originalButton.innerHTML = '<span class="fw-6">AJOUT...</span>';

    try {
      // Count valid products to add
      const validProducts = this.dropdowns.filter(d => d.selectedProduct && d.selectedProduct.variantId);
      console.log(`Adding ${validProducts.length} gift(s) to cart`);

      const randomId1 = Math.random().toString(36).substring(2, 15);
      const finalProperties = { ...(properties || {}), _random: randomId1 };

      // Add the discovery pack
      console.log('Adding discovery pack...');
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          properties: finalProperties
        }),
        credentials: 'same-origin',
      });

      // Add ALL free gifts ONLY if offer is not already used
      console.log(`[LaunchOffer] isOfferUsed: ${this.isOfferUsed}, dropdowns count: ${this.dropdowns.length}`);
      console.log(`[LaunchOffer] All dropdowns state:`, this.dropdowns.map((d, i) => ({
        index: i,
        hasSelectedProduct: !!d.selectedProduct,
        selectedProduct: d.selectedProduct
      })));

      if (!this.isOfferUsed) {
        for (let i = 0; i < this.dropdowns.length; i++) {
          const dropdown = this.dropdowns[i];
          console.log(`[LaunchOffer] Processing dropdown ${i}:`, dropdown.selectedProduct);

          if (dropdown.selectedProduct && dropdown.selectedProduct.variantId) {
            const randomId = Math.random().toString(36).substring(2, 15);
            console.log(`[LaunchOffer] Adding gift ${i}: ${dropdown.selectedProduct.handle} (ID: ${dropdown.selectedProduct.variantId})`);

            // Small delay between requests to avoid Shopify rate limiting
            if (i > 0) {
              await new Promise(resolve => setTimeout(resolve, 300));
            }

            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
              },
              body: JSON.stringify({
                id: dropdown.selectedProduct.variantId,
                quantity: 1,
                properties: { '_launch_offer_gift': 'true', '_show_in_progress': 'true', '_random': randomId }
              }),
              credentials: 'same-origin',
            });

            if (!response.ok) {
              console.error(`[LaunchOffer] ❌ Failed to add gift ${i}: ${response.status} ${response.statusText}`);
              // Retry once after a longer delay
              await new Promise(resolve => setTimeout(resolve, 500));
              const retryResponse = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                },
                body: JSON.stringify({
                  id: dropdown.selectedProduct.variantId,
                  quantity: 1,
                  properties: { '_launch_offer_gift': 'true', '_show_in_progress': 'true', '_random': randomId }
                }),
                credentials: 'same-origin',
              });
              if (retryResponse.ok) {
                console.log(`[LaunchOffer] ✅ Gift ${i} added on retry: ${dropdown.selectedProduct.handle}`);
              } else {
                console.error(`[LaunchOffer] ❌ Gift ${i} failed on retry too`);
              }
            } else {
              console.log(`[LaunchOffer] ✅ Gift ${i} added: ${dropdown.selectedProduct.handle}`);
            }
          } else {
            console.log(`[LaunchOffer] ⏭️ Skipping dropdown ${i}: no valid selectedProduct`);
          }
        }
      } else {
        console.log('ℹ️ Offer already used, adding pack only');
      }

      originalButton.innerHTML = '<span class="fw-6">AJOUTÉ</span>';

      document.dispatchEvent(new CustomEvent('product:added'));

      const sideCart = document.querySelector('side-cart');
      if (sideCart) {
        sideCart.classList.add('open');
      }

      setTimeout(() => this.checkOfferStatus(), 800);

    } catch (error) {
      console.error('Error adding products:', error);
      originalButton.innerHTML = originalText;
    } finally {
      originalButton.disabled = false;
      originalButton.removeAttribute('aria-busy');
      setTimeout(() => {
        originalButton.innerHTML = originalText;
      }, 1500);
    }
  }

  async checkOfferStatus() {
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());

      const giftHandles = ['caram-hellz', 'pop-pornz', 'fluffy-razberryz', 'speculooz-locoz'];

      const hasLaunchOfferGift = cart.items.some(item => {
        const isFreeGift = giftHandles.includes(item.handle) && item.final_price === 0;
        const hasGiftProperty = item.properties && item.properties.launch_offer_gift === 'true';
        return isFreeGift || hasGiftProperty;
      });

      const hasDiscoveryPack = cart.items.some(item =>
        item.handle.indexOf('decouverte') > -1
      );

      this.isOfferUsed = this.limitToOne && hasLaunchOfferGift && hasDiscoveryPack;

      if (hasLaunchOfferGift && !hasDiscoveryPack) {
        await this.removeOrphanGift(cart, giftHandles);
      }

      this.updateBlockState();
    } catch (error) {
      console.error('Error checking offer:', error);
    }
  }

  async removeOrphanGift(cart, giftHandles) {
    try {
      const giftItems = cart.items.filter(item => {
        const isFreeGift = giftHandles.includes(item.handle) && item.final_price === 0;
        const hasGiftProperty = item.properties && item.properties.launch_offer_gift === 'true';
        return isFreeGift || hasGiftProperty;
      });

      if (giftItems.length === 0) return;

      console.log('🗑️ Removing orphan gifts:', giftItems.map(i => i.title));

      const updates = {};
      giftItems.forEach(item => {
        updates[item.key] = 0;
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      });

      const sideCart = document.querySelector('side-cart');
      if (sideCart && typeof sideCart.refreshCart === 'function') {
        await sideCart.refreshCart();
      }
    } catch (error) {
      console.error('Error removing orphan gift:', error);
    }
  }

  updateBlockState() {
    if (this.isOfferUsed) {
      this.disableBlock();
      setTimeout(() => this.updateButtonPriceWithoutGift(), 500);
    } else {
      this.enableBlock();
    }
  }

  disableBlock() {
    const wrapper = this.element.querySelector('.launch-offer__wrapper');
    if (!wrapper) return;

    if (!wrapper.querySelector('.launch-offer__overlay')) {
      const overlayText = this.element.dataset.overlayText || 'Offre déjà utilisée !';

      const overlay = document.createElement('div');
      overlay.className = 'launch-offer__overlay';

      const textElement = document.createElement('div');
      textElement.className = 'launch-offer__overlay-text';
      textElement.textContent = overlayText;

      overlay.appendChild(textElement);
      wrapper.style.position = 'relative';
      wrapper.appendChild(overlay);
    }

    if (!this.element.querySelector('.launch-offer__additional-text')) {
      const additionalText = this.element.dataset.overlayAdditionalText || 'Mais tu peux quand même commander un deuxième coffret découverte';

      const textParagraph = document.createElement('p');
      textParagraph.className = 'launch-offer__additional-text p-small';
      textParagraph.textContent = additionalText;

      this.element.appendChild(textParagraph);
    }

    this.updateButtonPriceWithoutGift();

    this.dropdowns.forEach(dropdown => {
      if (dropdown.button) {
        dropdown.button.disabled = true;
        dropdown.button.style.pointerEvents = 'none';
      }
    });
  }

  enableBlock() {
    const overlay = this.element.querySelector('.launch-offer__overlay');
    if (overlay) overlay.remove();

    const additionalText = this.element.querySelector('.launch-offer__additional-text');
    if (additionalText) additionalText.remove();

    const buttons = document.querySelectorAll('.product-form__submit[data-action="add-to-cart"]');
    buttons.forEach(button => {
      const comparePriceEl = button.querySelector('.product-form__compare-price');
      if (comparePriceEl && comparePriceEl.parentElement.tagName === 'S') {
        comparePriceEl.parentElement.style.display = '';
      }
    });

    this.updateComparePrice();

    this.dropdowns.forEach(dropdown => {
      if (dropdown.button) {
        dropdown.button.disabled = false;
        dropdown.button.style.pointerEvents = '';
      }
    });
  }

  updateButtonPriceWithoutGift() {
    const buttons = document.querySelectorAll('.product-form__submit[data-action="add-to-cart"]');

    buttons.forEach(button => {
      const originalPriceCents = parseInt(button.getAttribute('data-original-price'));
      if (!originalPriceCents) return;

      const comparePriceEl = button.querySelector('.product-form__compare-price');
      if (comparePriceEl && comparePriceEl.parentElement.tagName === 'S') {
        comparePriceEl.parentElement.style.display = 'none';
      }

      const priceEl = button.querySelector('.product-form__price');
      if (priceEl) {
        priceEl.textContent = window.formatPrice(originalPriceCents);
      }
    });
  }

  initCartListeners() {
    document.addEventListener('product:added', () => {
      setTimeout(() => this.checkOfferStatus(), 1000);
    });

    document.addEventListener('cart:refreshed', () => {
      setTimeout(() => this.checkOfferStatus(), 300);
    });
  }

  destroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }
}

function initLaunchOffers() {
  const launchOfferElements = document.querySelectorAll('.launch-offer');

  launchOfferElements.forEach(element => {
    if (!element.dataset.initialized) {
      new LaunchOffer(element);
      element.dataset.initialized = 'true';
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLaunchOffers);
} else {
  initLaunchOffers();
}

document.addEventListener('shopify:section:load', initLaunchOffers);